import React from "react";

export default function BloginternsmalLoading() {
  const SmFunc = () => {
    return (
      <div className="lMs">
        <div></div>
        <div></div>
        <div></div>
      </div>
    );
  };

  return (
    <div className="smLoading">
      <SmFunc />
      <SmFunc />
    </div>
  );
}
